import { render, staticRenderFns } from "./VideoExercise.vue?vue&type=template&id=3c759209"
import script from "./VideoExercise.vue?vue&type=script&lang=js"
export * from "./VideoExercise.vue?vue&type=script&lang=js"
import style0 from "./VideoExercise.vue?vue&type=style&index=0&id=3c759209&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports